// extracted by mini-css-extract-plugin
module.exports =  {"button":"a10a3f92e9--button--pv5jF","dark":"a10a3f92e9--dark--SHfpm"};